import { FormsModule } from '@angular/forms';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalNewSimulatorComponent } from "./modal-newsimulator.component";
import { NbCardModule } from '@nebular/theme';
import { DirectiveModule } from '../../directives/directive.module';
import { fieldMsgErrorModule } from '../field-msg-error/field-msg-error.module';

@NgModule({
    imports: [
        CommonModule,
        NbCardModule,
        FormsModule,
        DirectiveModule,
        fieldMsgErrorModule
    ],
    exports: [
        ModalNewSimulatorComponent
    ],
    declarations: [
        ModalNewSimulatorComponent
    ],
    entryComponents: [
        ModalNewSimulatorComponent
    ]

})

export class ModalNewSimulatorModule {

}


// WEBPACK FOOTER //
// ./src/app/components/modal-newsimulator/modal-newsimulator.module.ts